/** used in table of contents */
document
    .querySelectorAll('[data-scroll-to]')
    .forEach((el) => {

        el.addEventListener('click', (e) => {

            const element = document.querySelector(el.dataset.scrollTo);
            if (element != undefined) {

                e.preventDefault();

                window.scrollTo({
                    top: element.offsetTop - document.querySelector('[data-role="header-shadow"]').offsetHeight,
                    behavior: 'smooth',
                });
            }
        });
    });

document
    .querySelectorAll('[data-scroll-x-to]')
    .forEach((el) => {

        el.addEventListener('click', (e) => {

            const element = el.closest('.container').querySelector(el.dataset.scrollXTo);
            if (element != undefined) {

                e.preventDefault();

                element.parentNode.scrollTo({
                    left: element.offsetLeft,
                    behavior: 'smooth',
                });
            }
        });
    });

setTimeout(() => {

    document
        .querySelectorAll('[data-scroll-watch]')
        .forEach((watch) => {

            const
                items = watch.querySelectorAll('[data-scroll-trigger]'),
                container = watch.closest('[data-scroll-container]');

            let
                timeoutWatch = null,
                lastActiveTap = container.querySelector(items[0].dataset.scrollTrigger),
                lastActiveTapId = 0;

            watch.addEventListener('scroll', () => {

                clearTimeout(timeoutWatch);
                setTimeout(() => {

                    for (let i = items.length - 1; i >= 0; i--) {

                        if (items[i].getBoundingClientRect().left <= watch.scrollLeft) {

                            if (lastActiveTapId != i) {

                                lastActiveTap.dataset.active = 0;

                                const tap = container.querySelector(items[i].dataset.scrollTrigger);
                                tap.dataset.active = 1;

                                lastActiveTap = tap;
                                lastActiveTapId = i;
                            }

                            break;
                        }
                    }

                    timeoutWatch = null;
                }, 50);
            });
        });
}, 100);